
import { AICostMonitoring } from './AICostMonitoring';
import { usePermissions } from '@/contexts/unified-permissions';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Loader2, ShieldCheck, ShieldX } from 'lucide-react';

export function AICostTab() {
  const { isAdmin, permissionsStatus } = usePermissions();
  
  // No need for useEffect - permissions are handled by the unified permissions system

  if (permissionsStatus === 'loading') {
    return (
      <div className="flex items-center justify-center p-12">
        <Loader2 className="h-8 w-8 animate-spin text-primary mr-2" />
        <p>Verifying admin permissions...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <Alert variant="destructive" className="mb-6">
        <ShieldX className="h-5 w-5 mr-2" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don't have administrator permissions to view AI cost data. 
          Please contact an admin if you believe this is an error.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-6">
      {isAdmin && (
        <Alert className="mb-6 border-green-200 bg-green-50 text-green-800">
          <ShieldCheck className="h-5 w-5 text-green-600 mr-2" />
          <AlertTitle>Admin Access Granted</AlertTitle>
          <AlertDescription>
            You have administrator permissions to view AI cost data.
          </AlertDescription>
        </Alert>
      )}
      <AICostMonitoring />
    </div>
  );
}
